import { useSearchParams } from 'react-router-dom';

export const PAGE_KEY = 'page';

export interface AttendeePage {
  page: number;
  setPage: (page: number) => void;
  updateParams: (params: URLSearchParams, newPage: number) => URLSearchParams;
}

export function useUrlPage(startPage: number): AttendeePage {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get(PAGE_KEY) || `${startPage}`); // Cloudscape pages are 1-indexed

  // This function allows us to mutate the searchparams alongside other search param hooks if needed
  // It does NOT perfom any changes to the url on it's own, and MUST be wrapped in a setSearchParams call
  const updateParams = (params: URLSearchParams, newPage: number) => {
    if (newPage === startPage) {
      params.delete(PAGE_KEY);
    } else {
      params.set(PAGE_KEY, `${newPage}`);
    }

    return params;
  };

  const setPage = (newPage: number) => {
    setSearchParams((params) => updateParams(params, newPage));
  };

  return {
    page,
    setPage,
    updateParams,
  };
}
